import React, {
    Component,
    useState
} from 'react';
import {connect} from 'react-redux';
import {
    bindActionCreators,
    Dispatch
} from 'redux';
import {enumerate} from 'ts-transformer-enumerate';

import _ from 'lodash';

import {
    TreeSelectionEvent
} from 'primereact/tree';

import Xarrow, {Xwrapper} from 'react-xarrows';

import TreeUtils from '~/frontend/src/utilities/TreeUtils';

import LoadingMaskPanel from '~/frontend/src/components/base/LoadingMaskPanel';

import ItemFinderDetailHeaderbar from '~/frontend/src/components/base/ItemFinder/detail/Headerbar';
import ViewDesignerToolbar from './Toolbar';
import ResizeableLeftMenuPanel from '~/frontend/src/components/base/shared/panel/ResizeableLeftMenuPanel';
import ItemTree, {AllProps as ItemTreeProps} from '~/frontend/src/components/base/shared/tree/ItemTree';

import './style.scss';
import Joi from '~/shared/src/utilities/joiExtended';
import {ContextMenu} from 'primereact/contextmenu';
import TreeNode from 'primereact/treenode/TreeNode';
import loadData from '~/frontend/src/actions/data/loadData';
import * as PanelActions from '~/frontend/src/actions/panel/common';
import * as TreeActions from '~/frontend/src/actions/panel/treeView';
import * as IntercomActions from '~/frontend/src/actions/intercom';
import * as CiActions from '~/frontend/src/actions/data';
import {
    AppDispatch,
    StoreState
} from '~/frontend/src/store';
import {
    PanelElusiveDataState
} from '~/frontend/src/reducers/elusiveData';
import {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import {UnsetParamAction} from '~/frontend/src/actions/panel/common/unsetParam';
import AttributesForm from '~/frontend/src/components/base/ItemFinder/detail/PropertiesPanel';
import setPanelDirty, {SetPanelDirty} from '~/frontend/src/actions/panelManager/setPanelDirty';
import Item from '~/shared/src/ci/Item';
import ciHelper from '~/shared/src/utilities/dataUtils';
import metaModel from '~/shared/src/utilities/metaModel';
import {Toast} from 'primereact/toast';
import {PanelIntercomState} from '~/frontend/src/reducers/intercom';
import {
    MsgParams,
    setMessage,
    unsetMessage
} from '~/frontend/src/actions/intercom';
import {
    clearElusiveData,
    clearElusiveDataForSubpanels,
    setElusiveData
} from '~/frontend/src/actions/elusiveData';
import {
    rawModeSchema,
    showAdditionalRawNamesSchema
} from '~/shared/src/validationSchemes/modules/overview';
import {requestBaseParametersSchema} from '~/shared/src/model/BaseRequest';
import setPanelInfo, {SetPanelInfo} from '~/frontend/src/actions/panelManager/setPanelInfo';
import {
    getItemKeyDisplayName,
    getItemNameDisplayName,
    getItemTypeDisplayName,
    getStatusColorStyleString,
    getStatusDisplayName
} from '~/frontend/src/utilities/renderHelpers';
import dataUtils from '~/shared/src/utilities/dataUtils';
import Form from '~/frontend/src/components/base/Form';
import User from '~/shared/src/model/User';
import {__} from '~/shared/src/utilities/messageCatalog';
import {formatTimestamp} from '~/shared/src/utilities/valueFormaters';
import keyboardUtils from '~/frontend/src/utilities/keyboardUtils';
import closePanel from '~/frontend/src/actions/panelManager/closePanel';
import {SaveDataResult} from '~/shared/src/utilities/modules/data';
import hideConfirmCloseDialog from '~/frontend/src/actions/panelManager/hideConfirmCloseDialog';
import saveData from '~/frontend/src/actions/panel/viewDesigner/saveData';
import {Toolbar} from 'primereact/toolbar';
import {
    Checkbox,
    CheckboxChangeEvent
} from 'primereact/checkbox';
import {confirmPopup} from 'primereact/confirmpopup';
import {
    Dropdown,
    DropdownChangeEvent
} from 'primereact/dropdown';
import cssRule from '~/frontend/src/utilities/cssRule';
import {
    isDataModified,
    isDataModifiedRecursive
} from '~/frontend/src/utilities/dataUtils';
import objectUtils from '~/shared/src/utilities/objectUtils';


type Variables = {
    [ variable : string ] : any;
};
type TreeInFocus = 'treeview' | 'DataObjects';
const treeInFocusKeys = enumerate<TreeInFocus>();

const defaultProps = {
    /**
     * The database schema to filter data and metadata for.
     */
    dataContext: 'viewDesigner' as string,
    //
    title: 'ViewDesigner' as string,
    //
    schema: 'CFG' as Schema,

    //
    treeViewKey: 'TreeViewEditor' as string,

    dataObjectViewKey: 'ViewEditor:DataObjects' as string,

    /**
     * The width of the menu on the left side in percent.
     */
    menuWidth: 50 as number,


    /**
     * The status to filter data for.
     */
    status: 'active' as Status,

    /**
     * The timestamp to filter data at.
     */
    timestamp: 'now' as string,

    /**
     * The timezone to filter data at.
     */
    timezone: 'Europe/Berlin' as string,

    /**
     * Show the MetaModel information as defined (raw) <strong>or</strong> should they be processed by MessageCatalog.
     */
    rawMode: false as boolean,

    /**
     * Show the MetaModel information as defined additionally for processed information.
     * This applies in the form: &lt;processed MetaModel information&gt; (&lt;defined MetaModel information&gt;)
     *
     * Only applicable if <prop>rawMode</prop> is set to false.
     */
    showAdditionalRawNames: false as boolean,

    tempData: {} as {
        metaData : any,
        data : any
    },

    showDataObjectTargets: {} as { [ groupName : string ] : boolean },

    treeInFocus: 'treeview' as TreeInFocus
};

type DefaultProps = Readonly<typeof defaultProps>;

/**
 * Definition of components props
 * @memberof TreeTest
 * @property {String} dataContext='cypher' The ci-data context of this component
 * @property {Object} items CI-Data as stored in redux store
 * @property {String} itemsVersion Version of CI-Data as stored in redux store
 */
type Props = {
    uid : string;

    /**
     * The ItemId to filter data and metadata for.
     */
    itemId? : number;

    // the ciId of the root item
    rootItemId : number
    rootItemKey : string;
    rootItemType : string;

    labelKey : string;

    /**
     * Should the MetaModel information shown as defined (raw) <strong>or</strong> should they be processed by MessageCatalog.
     */
    rawMode? : boolean;

    /**
     * Should the MetaModel information as defined additionally shown for processed information <strong>or</strong> not.
     * This applies in the form: &lt;processed MetaModel information&gt; (&lt;defined MetaModel information&gt;)
     *
     * Only applicable if <prop>rawMode</prop> is set to false.
     */
    showAdditionalRawNames? : boolean;

    /**
     * The elusive data (not persisted by redux store) for this component.
     * A storage for temporary needed data (not persisted to local storage via redux store persist), like
     *  - lastParams: The stringified parameters of the last loaded search. Used to determine if a new result have to be loaded from the backend.
     *  - gridData: The ordered itemIds to display in the grid.
     *  - totalRecords: The total result data count to be displayed in the DataTable.
     *
     * Will be mapped from global state.
     */
    elusiveData? : PanelElusiveDataState;

    treeVariables? : {
        treeview? : Variables;
        DataObjects? : Variables;
    };

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;

    /**
     * The props for sub panels
     */
    subPanelProps? : any;

    /**
     * The intercom messages for this component.
     *
     * Will be mapped from global state.
     */
    intercomMessages? : PanelIntercomState;

    //
    // action functions
    deleteReference? : Function;
    addReference? : Function;
    clearCiData? : Function;
    loadTree? : Function;

    itemTreeProps? : { [ itemTreeUid : string ] : ItemTreeProps };
};

const Actions = Object.assign( { loadData, setMessage, unsetMessage, setElusiveData, clearElusiveData, clearElusiveDataForSubpanels, setPanelInfo, setPanelDirty }, PanelActions, TreeActions, IntercomActions, CiActions );

type SetParamProps = ItemTreeProps & {
    menuWidth : number,
    showDataObjectTargets : { [ groupName : string ] : number[] },
    treeInFocus : string
};

type SetParam = <K extends keyof SetParamProps>( panelKey : string, paramKey : K, paramValue : SetParamProps[K] ) => SetParamAction;
type UnsetParam = ( panelKey : string, paramKey : keyof ItemTreeProps ) => UnsetParamAction;

/**
 * Function props mapped by mapDispatchToProps
 */
type ActionProps = {
    //updatePanelProps: typeof updatePanelProps;
    loadData : typeof loadData;
    setParam : SetParam;
    unsetParam : UnsetParam;
    setMessage : typeof setMessage;
    unsetMessage : typeof unsetMessage;
    setPanelInfo : SetPanelInfo;
    setElusiveData : typeof setElusiveData;
    clearElusiveData : typeof clearElusiveData;
    clearElusiveDataForSubpanels : typeof clearElusiveDataForSubpanels;
    setPanelDirty : SetPanelDirty;
};

type AllProps = Props & DefaultProps & ActionProps;
export type ComponentProps = Partial<DefaultProps> & Props;

type State = Partial<{
    // the ciId of the currently selected tree node
    rootItemId : number;
    selectedItemParentId? : number;

    treeMetaData? : TreeNode.TreeNode[];

    /**
     * TreeUtils of both trees,
     * needed to have access to TreeNode Ids to paint the arrows
     */
    treeViewTreeUtils : TreeUtils;
    dataObjectTreeUtils : TreeUtils;

    selectedArrow : string[];

    isDirty : boolean;
    errorCount : number;

    /**
     * Counts up on menu scroll. Used to fire update for arrows
     */
    scrollIndicator : number;
}>;

/**
 * Playground to test Tree implementation
 */
class ViewDesigner extends Component<AllProps, State> {

    static defaultProps = defaultProps;

    // panel manager config
    static panelType = 'ViewDesigner';
    static panelTabTitle = 'ViewDesigner';
    static panelTabIcon = 'fa fa-stream';

    static panelPropsSchemaMsgIdPrefix = 'YN.base.viewDesigner';
    static panelPropsSchema = Joi.object()
        // panelSchema defaults
        .concat( requestBaseParametersSchema )
        .concat( Joi.object( {
            panelType        : Joi.string().valid( ViewDesigner.panelType ),
            treeViewKey      : Joi.string(),
            dataObjectViewKey: Joi.string(),
            panelTabTitle    : Joi.string().default( ViewDesigner.panelTabTitle ),
            panelTabIcon     : Joi.string().default( ViewDesigner.panelTabIcon ),
            rootItemId       : Joi.number().description( 'Id of the payload root item.' ),
            rootItemType     : Joi.string().description( 'Item Type of the payload root item.' ),
            rootItemKey      : Joi.string().description( 'Key of the payload root item.' ),
            labelKey         : Joi.string(),
            menuWidth        : Joi.number()
                .default( 15 )
                .description( 'The width of the left menu panel in percent of the available width.' ),
            // this is only for compatibility with ItemFinder overview (if we open this panel from there)
            rawMode               : rawModeSchema,
            showAdditionalRawNames: showAdditionalRawNamesSchema
        } ) );

    static initialState = {

        rootItemId: 0 as number,

        isDirty   : false,
        errorCount: 0,

        scrollIndicator: 0 as number
    };

    cm? : InstanceType<typeof ContextMenu> | null;

    toast? : Toast | null;

    // TODO: move this in panel manager. Discuss? (tk)
    state = ViewDesigner.initialState as State; /*JSON.parse( localStorage.getItem( 'ViewDesigner' ) ?? 'null' ) || Object.assign( {
        //cypherQuery: this.constructor.cypherQueries[0].cypher,
        //schema: this.constructor.cypherQueries[0].schema || 'DATA'
    }, ViewDesigner.initialState );*/

    getTreeContextMenu = ( treeData : TreeNode.TreeNode[], key : string ) => [
        {
            label  : 'Collapse all',
            icon   : 'far fa-minus-square',
            command: function() {
                this.setState( { [ key ]: {} } );
            }.bind( this )
        },
        {
            label  : 'Expand all',
            icon   : 'far fa-plus-square',
            command: function() {
                const expandedKeys : { [ key : string ] : true } = {};
                const expandNode = ( node : TreeNode.TreeNode ) => {
                    if ( node.children?.length ) {
                        expandedKeys[ node.key! ] = true;

                        for ( const child of node.children ) {
                            expandNode( child );
                        }
                    }
                }

                for ( const node of treeData ) {
                    expandNode( node );
                }

                this.setState( { [ key ]: expandedKeys } );
            }.bind( this )
        }
    ];

    /**
     * React Component constructor
     * @param {Object} props
     */
    constructor( props : AllProps ) {
        super( props );

        this.onReloadButtonClick = this.onReloadButtonClick.bind( this );
        this.onSetTreeVariables = this.onSetTreeVariables.bind( this );
        this.onGetTreeUtils = this.onGetTreeUtils.bind( this );
        this.onSelectItem = this.onSelectItem.bind( this );
        this.onMenuWidthChange = this.onMenuWidthChange.bind( this );
        this.getTreeNodeIdPairs = this.getTreeNodeIdPairs.bind( this );
        this.toggleShowDataObjectTargets = this.toggleShowDataObjectTargets.bind( this );
    }

    /**
     * REDUX stuff
     */
    static getDerivedStateFromProps( props : AllProps, state : State ) : Partial<State> {
        const {
                  tempData,
                  rootItemId,
                  rootItemKey,
                  rootItemType,
                  dataContext,
                  schema
              } = props;

        return {
            rootItemId  : rootItemId || ( dataContext && rootItemType && rootItemKey ? dataUtils.findItem( dataContext, rootItemType, rootItemKey )?.id ?? 0 : state.rootItemId ),
            isDirty     : rootItemId ? isDataModifiedRecursive( dataContext, schema, rootItemId ) : isDataModified( dataContext, schema! ),
            treeMetaData: tempData?.data?.treeData
        };
    }

    /**
     * REACT lifecycle method
     */
    componentDidMount() {
        this.afterRender();
    }

    /**
     * REACT lifecycle method
     */
    componentDidUpdate() {
        this.afterRender();
    }

    /**
     * REACT lifecycle method
     */
    shouldComponentUpdate( nextProps : AllProps, nextState : State ) : boolean {
        if (
            ( nextState.isDirty !== undefined && nextState.isDirty !== this.state.isDirty )
        ) {
            this.props.setPanelDirty( this.props.uid, nextState.isDirty );
        }

        return true;
    }

    /**
     * YOONITE lifecycle method
     */
    static onSavePanelAction( props : ComponentProps ) {
        return async ( dispatch : AppDispatch, getState : () => StoreState ) => {
            await ViewDesigner.savePanelData(
                dispatch,
                getState,
                props
            );
        }
    }

    /**
     * YOONITE lifecycle method
     */
    static onSaveAndClosePanelAction( props : ComponentProps ) {
        return async ( dispatch : AppDispatch, getState : () => StoreState ) => {
            const result = await ViewDesigner.savePanelData(
                dispatch,
                getState,
                props,
                [
                    props.uid,
                    'notification',
                    'saveSuccess',
                    'closePanel'
                ]
            );

            // no save error -> close panel
            if ( result !== false && result.success ) {
                await dispatch( closePanel( props.uid ) );
            }
        }
    }

    static async savePanelData( dispatch : AppDispatch, getState : () => StoreState, props : ComponentProps, successMsgParams : MsgParams | undefined = undefined ) : Promise<SaveDataResult | false> {
        const propsWithDefaults : DefaultProps & Props = {
                  ...defaultProps,
                  ...props
              },
              {
                  uid,
                  rootItemId,
                  schema
              }                                        = propsWithDefaults,
              elusiveData                              = getState()?.elusiveData?.[ uid ],
              errorData                                = elusiveData?.errorData as PanelErrorData[ 'errorData' ];

        // panel has errors -> show popup
        if ( errorData?.count ) {
            dispatch( hideConfirmCloseDialog( uid ) );
            dispatch( setElusiveData( uid, { showCouldNotSavePopup: true } ) );

            return Promise.resolve( false );
        }

        // panel has no errors -> save
        else {
            return dispatch( saveData(
                uid,
                schema,
                rootItemId ?? elusiveData?.data?.rootItemId,
                undefined,
                undefined,
                successMsgParams
            ) );
        }
    }

    afterRender( props : AllProps = this.props as AllProps ) {
        this.checkForIntercomMessages( props );
        this.setPanelInfo(
            this.props.uid,
            'CFG',
            this.props.status,
            this.props.timezone,
            this.props.timestamp,
            this.props.rootItemId,
            this.props.rawMode,
            this.props.showAdditionalRawNames,
            this.state.isDirty!,
            this.state.errorCount!,
            this.props.elusiveData?.data?.items?.[ this.props.rootItemId ] ?? 0
        );
    }

    /**
     * Sets the title and icon for the tab of this component.
     *
     * @private
     */
    setPanelInfo( uid : string, schema : Schema, status : Status, timezone : string, timestamp : string, rootItemId : number, rawMode : boolean, showAdditionalRawNames : boolean, isDirty : boolean, errorCount : number, rootItemRevision : number ) {
        const item = global.data[ uid ]?.items?.[ rootItemId ];

        let title            = __( ViewDesigner.panelTabTitle ),
            icon             = ViewDesigner.panelTabIcon,
            tooltip : string = '';

        if ( item ) {
            const itemLabel       = item.displayAttributeValue,
                  itemTypeLabel   = getItemTypeDisplayName( item.itemTypeId, schema, rawMode, showAdditionalRawNames ),
                  itemStatusStyle = getStatusColorStyleString( item.statusId, schema ),
                  itemId          = item.id > 0 ? item.id : 'NEW',
                  itemTypeIcon    = item.itemType.icon;

            title = `${itemLabel} (${itemId})`;

            // TODO: add special tree icons for ItemTypes to CSS
            if ( itemTypeIcon ) {
                icon = `yn-tab-image-icon icon-itemtype-detail ${itemTypeIcon}`;
            }

            tooltip += `<div className="yn-tooltip-header">${__( 'YN.base.viewDesigner.tooltip.title', { itemLabel: `<span ${itemStatusStyle}>${itemLabel}</span>` } )}</div>`;

            // error
            if ( errorCount ) {
                tooltip += `<div className="yn-tooltip-info mb-0">
                            <div className="yn-tooltip-info-title"><span className="fas fa-exclamation-circle yn-error mr-2"></span> ${__( 'YN.base.panel.tooltip.hasError' )}</div>
                        </div>`;
            }

            // dirty
            else if ( isDirty ) {
                tooltip += `<div className="yn-tooltip-info mb-0">
                            <div className="yn-tooltip-info-title"><span className="fas fa-exclamation-triangle yn-dirty mr-2"></span> ${__( 'YN.base.panel.tooltip.isDirty' )}</div>
                        </div>`;
            }

            // item information
            tooltip += `<div className="yn-tooltip-info">`;
            tooltip += `<div className="yn-tooltip-info-row">`;
            tooltip += `<div className="yn-tooltip-info-content flex-1">
                                <div className="yn-tooltip-info-content-label">${getItemKeyDisplayName( item.itemTypeId, schema, rawMode, showAdditionalRawNames )}</div>
                                <div className="yn-tooltip-info-content-text" style="font-size: 1.25rem; white-space: nowrap;">${item.key}</div>
                            </div>`;
            tooltip += `<div className="yn-tooltip-info-content flex-1">
                                <div className="yn-tooltip-info-content-label">${getItemNameDisplayName( item.itemTypeId, schema, rawMode, showAdditionalRawNames )}</div>
                                <div className="yn-tooltip-info-content-text" style="font-size: 1.25rem; white-space: nowrap;">${item.name}</div>
                            </div>`;
            tooltip += `<div className="yn-tooltip-info-content flex-none" style="width: 4rem; text-align: right;">
                                <div className="yn-tooltip-info-content-label">${__( 'YN.base.finder.item.idLabel' )}</div>
                                <div className="yn-tooltip-info-content-text" style="font-size: 1.25rem;">${itemId}</div>
                            </div>`;
            tooltip += `</div>`;
            tooltip += `<div className="yn-tooltip-info-row">`;
            tooltip += `<div className="yn-tooltip-info-content flex-none" style="width: calc( 50% - 3rem );">
                                <div className="yn-tooltip-info-content-label">${__( 'YN.base.finder.item.typeLabel' )}</div>
                                <div className="yn-tooltip-info-content-text">${itemTypeLabel}</div>
                            </div>`;
            tooltip += `<div className="yn-tooltip-info-content flex-1">
                                <div className="yn-tooltip-info-content-label">${__( 'YN.base.finder.status' )}</div>
                                <div className="yn-tooltip-info-content-text"><span ${itemStatusStyle}>${getStatusDisplayName( item.statusId, schema, rawMode, showAdditionalRawNames )}</span></div>
                            </div>`;
            tooltip += `</div>`;
            tooltip += '</div>';

            // adv search options
            if ( status !== 'active' || timestamp !== 'now' ) {
                tooltip += `<div className="yn-tooltip-info">
                                <div className="yn-tooltip-info-title">${__( 'YN.base.finder.tooltip.advSearchOptions' )}</div>`;
            }
            // status
            if ( status !== 'active' ) {
                let statusLabel = '';

                switch ( status ) {
                    case 'all-non-history':
                        statusLabel = __( 'YN.base.status.allNonHistory' );
                        break;
                    case 'all':
                        statusLabel = __( 'YN.base.status.all' );
                        break;
                }

                tooltip += `<div className="yn-tooltip-info-content">
                                <div className="yn-tooltip-info-content-label">${__( 'YN.base.finder.status.label' )}</div>
                                <div className="yn-tooltip-info-content-text">${statusLabel}</div>
                            </div>`;
            }
            // timestamp
            if ( timestamp !== 'now' ) {
                tooltip += `<div className="yn-tooltip-info-content">
                                <div className="yn-tooltip-info-content-label">${__( 'YN.base.finder.timestamp.label' )}</div>
                                <div className="yn-tooltip-info-content-text">${formatTimestamp( timestamp, timezone )}</div>
                            </div>`;
            }
            if ( status !== 'active' || timestamp !== 'now' ) {
                tooltip += `</div>`;
            }
        }

        this.props.setPanelInfo( this.props.uid, { title, icon, tooltip } );
    }

    /**
     * Checks if there are intercom messages present and shows them if.
     *
     * @private
     */
    checkForIntercomMessages( props : AllProps = this.props as AllProps ) {
        // check for toasts
        if ( this.toast && props.intercomMessages?.toast ) {
            const toastKeys = Object.keys( props.intercomMessages.toast );
            for ( const key of toastKeys ) {
                // show toast
                if ( props.intercomMessages.toast[ key ] ) {
                    this.toast.show( props.intercomMessages.toast[ key ] );
                }

                // clear toast message
                this.props.unsetMessage?.( this.props.uid, 'toast', key as string );
            }
        }
    }

    /**
     * Handler for getting TreeUtils of both trees used in this panel
     *
     * @param uid
     * @param treeUtils
     */
    onGetTreeUtils( uid : string, treeUtils : TreeUtils ) {
        if ( uid === this.props.uid + '_treeview' ) {
            this.setState( { treeViewTreeUtils: treeUtils } );
        }
        else {
            this.setState( { dataObjectTreeUtils: treeUtils } );
        }
    }

    /**
     * Handler for onSelectItem event of ItemTrees
     * Used to add references between DataObjects and Item if metaKey (e.g. COMMAND key on Mac) is hold
     * @param selectedKey
     * @param selectedPayloadId
     * @param event
     * @param parentKey
     * @param parentItemId
     */
    onSelectItem( selectedKey : string, selectNodeId : number, selectedPayloadId : number, event : TreeSelectionEvent, parentKey : string, parentItemId : number, treeUid : string ) {
        const {
                  dataContext,
                  subPanelProps,
                  uid
              }                      = this.props,
              matches                = treeUid.match( `^${uid}_(.*)$` ),
              subPanelKey            = matches?.[ 1 ] ?? '',
              otherSelectedPayloadId = subPanelProps[ subPanelKey === 'treeview' ? 'DataObjects' : 'treeview' ]?.selectedPayloadId,
              originalEvent          = event.originalEvent as React.KeyboardEvent;

        if ( keyboardUtils.cmdKey( originalEvent ) && dataContext && selectedPayloadId && otherSelectedPayloadId && selectedPayloadId !== otherSelectedPayloadId ) {
            const item      = global.data[ dataContext ]?.items[ selectedPayloadId ],
                  otherItem = global.data[ dataContext ]?.items[ otherSelectedPayloadId ];

            if ( item && otherItem ) {
                const dataObject = item.itemType.name === 'DataObject' ? item : ( otherItem.itemType.name === 'DataObject' ? otherItem : undefined ),
                      linkedItem = item.itemType.name === 'DataObject' ? ( otherItem.itemType.name !== 'DataObject' ? otherItem : undefined ) : item;

                if ( dataObject && linkedItem ) {
                    const dataObjectReferences = dataObject.references.map( refId => global.data[ dataContext ].references[ refId ] ),
                          linkedItemReferences = linkedItem.references.map( refId => global.data[ dataContext ].references[ refId ] ),
                          possibleRefSets      = metaModel.CFG.getReferenceSetsForItemTypesAndReferenceType( 'DataObject', linkedItem.itemTypeId, '*', 'src' )
                              .filter(
                                  ( referenceSet ) => {
                                      let retVal = true;

                                      if ( referenceSet.cardinality.indexOf( '1:' ) !== -1 ) {
                                          if ( linkedItemReferences.find( ref => ref.referenceSetId === referenceSet.id ) ) {
                                              retVal = false;
                                          }
                                      }
                                      else if ( referenceSet.cardinality.indexOf( ':1' ) !== -1 ) {
                                          if ( dataObjectReferences.find( ref => ref.referenceSetId === referenceSet.id ) ) {
                                              retVal = false;
                                          }
                                      }
                                      else if ( dataObjectReferences.find( ref => ref.referenceSetId === referenceSet.id )?.destItemId === linkedItem.id ) {
                                          retVal = false;
                                      }

                                      return retVal;
                                  }
                              ),
                          addDataObjectRef     = ( cirsId : number ) => {
                              this.props.addReference?.( dataContext, {
                                  referenceSetId: cirsId,
                                  srcItemId     : dataObject.id,
                                  destItemId    : linkedItem.id
                              } );
                          }

                    if ( possibleRefSets.length === 1 ) {
                        addDataObjectRef( possibleRefSets[ 0 ].id );
                    }
                    else if ( possibleRefSets.length ) {
                        let chosenReferenceSetId = possibleRefSets[ 0 ].id;

                        const Message = () : React.ReactElement => {
                            const [ rsetId, setRsetId ] = useState( chosenReferenceSetId );

                            return (
                                <Dropdown
                                    options={possibleRefSets.map( rset => {
                                        return { id: rset.id, referenceTypeLabel: rset.referenceType.label };
                                    } )}
                                    optionValue="id"
                                    optionLabel="referenceTypeLabel"
                                    value={rsetId}
                                    onChange={( dde : DropdownChangeEvent ) => {
                                        chosenReferenceSetId = dde.value;
                                        setRsetId( dde.value );
                                    }}
                                />
                            );
                        }

                        void confirmPopup( {
                            target         : document.getElementById( selectedKey as string ) ?? undefined,
                            message        : <><Message/></>,
                            icon           : 'pi pi-question-circle',
                            className      : 'yn-itemtree-confirm-popup',
                            acceptLabel    : __( 'YN.base.common.ok' ),
                            acceptClassName: 'p-button-success p-button-outlined',
                            rejectLabel    : __( 'YN.base.common.cancel' ),
                            rejectClassName: 'p-button-secondary p-button-outlined mr-3',
                            accept         : () => {
                                addDataObjectRef( chosenReferenceSetId );
                            }
                        } ).show;
                    }
                    else {
                        this.props.setMessage(
                            uid,
                            'toast',
                            'noPossibleRefSets',
                            {
                                severity: 'info',
                                summary : __( 'YN.base.treeView.addReference.noPossibleRefSets.title' ),
                                detail  : __( 'YN.base.treeView.addReference.noPossibleRefSets.text' )
                            } );
                    }
                }
            }

        }

        if ( subPanelKey ) {
            this.props.setParam?.( uid, 'treeInFocus', subPanelKey );
        }
        this.setState( {
            selectedArrow       : undefined,
            selectedItemParentId: parentItemId
        } );
    }

    onReloadButtonClick() {
        const { uid, dataContext } = this.props;


        if ( dataContext ) {

            this.props.clearElusiveData?.( uid );
            this.props.clearElusiveDataForSubpanels?.( uid );
            this.props.clearElusiveData?.( uid + '_treeview' );
            this.props.clearElusiveDataForSubpanels?.( uid + '_treeview' );
            this.props.clearElusiveData?.( uid + '_DataObjects' );
            this.props.clearElusiveDataForSubpanels?.( uid + '_DataObjects' );

            // clean data
            delete global.data[ dataContext + '-meta' ];
            delete global.data[ dataContext ];

            this.props.setMessage?.( this.props.uid + '_treeview', 'notification', 'reload', true );
            this.props.setMessage?.( this.props.uid + '_DataObjects', 'notification', 'reload', true );

        }
    }

    onSetTreeVariables( variables : Variables ) {
        const {
                  uid,
                  treeInFocus,
                  treeVariables
              }                = this.props,
              changedVariables = objectUtils.getDiffKeys(
                  treeVariables?.[ treeInFocus ] ?? {},
                  variables ?? {}
              );

        if ( changedVariables.length ) {
            this.props.setElusiveData( `${uid}_${treeInFocus}`, { variables: variables } );
        }
    }

    /**
     * Handler for menu width change.
     *
     * @private
     */
    onMenuWidthChange( width : number ) {
        this.props.setParam?.( this.props.uid, 'menuWidth', width );
    }

    /**
     * Retrieves ids of all DataObject / Item TreeNodes pairs
     */
    getTreeNodeIdPairs() : string[][] {
        const retVal : string[][] = [];
        const { showDataObjectTargets, dataContext } = this.props;
        const { dataObjectTreeUtils, treeViewTreeUtils } = this.state;
        if ( dataContext ) {
            const references = global.data[ dataContext ]?.references;
            let relevantCirsId : number[] = [];
            const groupToCirsIdMapping = treeViewTreeUtils?.getItemTypeGroupsReferencedToDataObject() ?? {};
            Object.keys( groupToCirsIdMapping ).forEach( groupName => {
                if ( showDataObjectTargets[ groupName ] !== false ) {
                    relevantCirsId = relevantCirsId.concat( groupToCirsIdMapping![ groupName ] )
                }
            } );
            if ( references && relevantCirsId.length ) {
                _.forOwn( references, reference => {
                    if ( relevantCirsId.includes( reference.referenceSetId ) && reference.status.name === 'active' && showDataObjectTargets[ ( reference.destItem?.itemType.name ?? '' ) ] !== false ) {
                        const dataObjectNodeIds = dataObjectTreeUtils?.getDynamicNodeIdByPayloadId( reference.srcItemId ) ?? [];
                        const dynamicNodeNodeIds = treeViewTreeUtils?.getDynamicNodeIdByPayloadId( reference.destItemId ) ?? [];
                        for ( const doNodeId of dataObjectNodeIds ) {
                            for ( const dnNodeId of dynamicNodeNodeIds ) {
                                retVal.push( [ doNodeId, dnNodeId ] );
                            }
                        }
                    }
                } );
            }
        }
        return retVal;
    }

    /**
     * Delete reference between DataObject and Item on context menu click
     */
    deleteDataObjectReference() {
        const { dataContext } = this.props;
        if ( dataContext ) {

            const { selectedArrow } = this.state,
                  linkedItemId      = this.state.treeViewTreeUtils?.getNodeById( selectedArrow?.[ 1 ] ?? '' )?.data?.payloadId ?? 0,
                  linkedItem        = global.data[ dataContext ]?.items?.[ linkedItemId ],
                  dataObjectId      = this.state.dataObjectTreeUtils?.getNodeById( selectedArrow?.[ 0 ] ?? '' )?.data?.payloadId ?? 0,
                  referenceSets     = metaModel.CFG.getReferenceSetsForItemTypesAndReferenceType( 'DataObject', linkedItem.itemTypeId, '*', 'src' ),
                  cirsId            = referenceSets.find( rset => {
                      return !!linkedItem.references.find( refId => {
                          const reference = global.data[ dataContext ]?.references?.[ refId ];
                          return reference.referenceSet.id === rset.id && reference.statusId !== -1;
                      } )
                  } )?.id;

            if ( linkedItemId && dataObjectId && cirsId ) {
                const reference = ciHelper.findReference( this.props.dataContext!, cirsId, dataObjectId, linkedItemId );
                if ( reference ) {
                    this.props.deleteReference?.( this.props.dataContext, reference.id, true, [ this.props.uid + '_treeview', this.props.uid + '_DataObjects' ] );
                }
            }

            this.setState( { selectedArrow: undefined } );
        }
    }

    toggleShowDataObjectTargets( e : CheckboxChangeEvent ) {
        const { showDataObjectTargets, uid } = this.props;
        this.props.setParam( uid, 'showDataObjectTargets', { ...showDataObjectTargets, ...{ [ e.value ]: e.checked } } )
    }

    /**
     * React render method
     * @return {*}
     */
    render() {
        const {
                  user,
                  showDataObjectTargets
              }                          = this.props,
              {
                  selectedArrow,
                  rootItemId = 0,
                  treeViewTreeUtils,
                  dataObjectTreeUtils
              }                          = this.state,
              {
                  dataContext,
                  uid,
                  schema,
                  treeViewKey,
                  dataObjectViewKey,
                  rootItemKey,
                  rootItemType,
                  status,
                  timestamp,
                  timezone,
                  menuWidth,
                  subPanelProps,
                  treeInFocus,
                  treeVariables
              }                          = this.props as AllProps,
              attributesPanelProps       = subPanelProps?.[ 'attributes' ],
              selectedPayloadId          = subPanelProps?.[ treeInFocus ]?.selectedPayloadId || rootItemId,
              selectedPayloadReferenceId = subPanelProps?.[ treeInFocus ]?.selectedPayloadReferenceId,
              treeUtils                  = treeInFocus === 'treeview' ? treeViewTreeUtils : dataObjectTreeUtils,
              // select root node if selectedKey isn't defined
              selectedKey                = subPanelProps?.[ treeInFocus ]?.selectedKey
                  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                  || treeUtils?.getDynamicNodeIdByPayloadReferenceId( selectedPayloadReferenceId )[ 0 ]
                  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                  || treeUtils?.getDynamicNodeIdByPayloadId( selectedPayloadId )[ 0 ],
              rootItem                   = global.data[ dataContext ]?.items?.[ rootItemId ],
              parentNode                 = treeUtils?.getNodeById( treeUtils?.getNodeById( selectedKey )?.data?.parentNodeId ?? rootItemId ),
              parentPayloadId            = parentNode?.data.payloadId || parentNode?.data.delegatedPayloadId || rootItemId;

        const dataObjectTargets = Object.keys( treeViewTreeUtils?.getItemTypeGroupsReferencedToDataObject() ?? {} );
        const treeNodeIdPairs = this.getTreeNodeIdPairs();

        const rawMode                = false,
              showAdditionalRawNames = false;

        let item : Item | undefined;

        const treeItemIds : number[] = ( [] as number[] ).concat( treeViewTreeUtils?.getPayloadIdsOfNodes() ?? [], dataObjectTreeUtils?.getPayloadIdsOfNodes() ?? [] );

        if ( selectedPayloadId ) {
            item = global.data[ dataContext ]?.items?.[ selectedPayloadId ];
        }

        const panelConfig            = user && item ? user.getPanelPropsForItemType( schema, item.itemTypeId, undefined, 'Form' )[ 0 ] : null,
              formProps              = subPanelProps?.[ `form-${item?.id ?? 0}` ],
              selectedArrowColor     = cssRule( '.yn-arrow-selected', 'color' ) as unknown as string, //'red'
              linkedToNodeArrowColor = cssRule( '.yn-arrow-linked', 'color' ) as unknown as string, //'CornflowerBlue'
              arrowColor             = cssRule( '.yn-arrow', 'color' ) as unknown as string; //'lightgray'

        return <>
            <ContextMenu
                model={[
                    {
                        label  : 'Delete reference',
                        icon   : 'pi pi-minus-circle',
                        command: () => this.deleteDataObjectReference()
                    }
                ]}
                ref={cm => this.cm = cm}
            />
            <ItemFinderDetailHeaderbar
                key={`${uid}_ItemFinderHeaderbar`}

                uid={uid}

                schema={schema}
                status={status}
                timestamp={timestamp}
                timezone={timezone}

                item={rootItem}

                rawMode={rawMode}
                showAdditionalRawNames={showAdditionalRawNames}

                showId={true}
                showType={true}
                showKey={true}
                showName={true}
                showStatus={true}
            />
            <ViewDesignerToolbar
                key={`${uid}_ItemFinderToolbar`}

                uid={uid}

                dataContext={dataContext}
                schema={schema}

                rootItemId={rootItemId}

                treeViewItem={rootItem}

                treeItemIds={treeItemIds}

                onReloadButtonClick={this.onReloadButtonClick}

                showSaveButton={true}
                showCloneButton={true}
                showDeleteButton={true}
                showHistoryButton={true}

            />
            <LoadingMaskPanel forComponent={uid} className="yn-flex-layout-parent">
                <Toast
                    ref={( el ) => this.toast = el}

                    key={`${uid}_toast`}

                    position="bottom-right"
                    style={{ position: 'absolute', marginTop: '0' }}
                />
                <Xwrapper>
                    <ResizeableLeftMenuPanel
                        key={`${uid}_menuContentPanel`}

                        uid={uid}

                        menuWidth={menuWidth}
                        minMenuWidth={15}
                        maxMenuWidth={50}
                        menuStyle={{ height: '100%', overflowY: 'hidden' }}
                        onMenuScroll={_.throttle( () => this.setState( { scrollIndicator: this.state.scrollIndicator! + 1 } ), 100 )}

                        menu={<div
                            style={{ position: 'relative', height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ position: 'relative', zIndex: 1, flex: '1 1 1px', overflowY: 'auto' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', zIndex: 1, width: '100%' }}>
                                    <div style={{ flexBasis: '50%', minWidth: '50%' }}>
                                        <div style={{ margin: '0 1rem' }}>
                                            <h2>DataObjects</h2>
                                        </div>
                                        <ItemTree
                                            {...this.props.subPanelProps?.[ 'DataObjects' ]}
                                            selectedKey={treeInFocus === 'DataObjects' ? this.props.subPanelProps?.[ 'DataObjects' ]?.selectedKey ?? '' : 'x'}
                                            className="yn-sidebar-content"
                                            style={{ height: 'auto', width: 'calc(100% - 4rem)' }}
                                            dataContext={dataContext}
                                            uid={uid + '_DataObjects'}
                                            parentUid={uid}
                                            useElusiveDataFromDataContext={false}
                                            schema="CFG"
                                            onGetTreeUtils={this.onGetTreeUtils}
                                            onSelectItem={this.onSelectItem}
                                            keepExistingOnReload
                                            apiParams={{
                                                viewKey: dataObjectViewKey,
                                                schema : 'CFG',
                                                rootItemId,
                                                rootItemKey,
                                                rootItemType,
                                                // TODO: set this flag only if metaData is requested for xml export
                                                includeMetaData: true
                                            }}
                                        />
                                    </div>
                                    <div style={{ flexBasis: '50%', minWidth: '50%' }}>
                                        <div style={{ margin: '0 1rem' }}>
                                            <h2>TreeView</h2>
                                        </div>
                                        <ItemTree
                                            {...this.props.subPanelProps?.[ 'treeview' ]}
                                            selectedKey={treeInFocus === 'treeview' ? this.props.subPanelProps?.[ 'treeview' ]?.selectedKey ?? '' : 'x'}
                                            className="yn-sidebar-content"
                                            style={{ height: 'auto' }}
                                            dataContext={dataContext}
                                            uid={uid + '_treeview'}
                                            parentUid={uid}
                                            // TODO: this is a temp solution, allowing the left tree to be in sync with the edited data, find a proper solution to sync both
                                            useElusiveDataFromDataContext={true}
                                            schema="CFG"
                                            onGetTreeUtils={this.onGetTreeUtils}
                                            onSelectItem={this.onSelectItem}
                                            keepExistingOnReload
                                            apiParams={{
                                                viewKey: treeViewKey,
                                                schema : 'CFG',
                                                rootItemId,
                                                rootItemKey,
                                                rootItemType,
                                                // TODO: set this flag only if metaData is requested for xml export
                                                includeMetaData: true
                                            }}
                                        />
                                    </div>
                                    {treeNodeIdPairs.map( treeNodeIdPair =>
                                        <Xarrow
                                            key={treeNodeIdPair[ 0 ] + '-' + treeNodeIdPair[ 1 ]}
                                            path="grid"
                                            color={
                                                selectedArrow?.[ 0 ] === treeNodeIdPair[ 0 ] && selectedArrow?.[ 1 ] === treeNodeIdPair[ 1 ]
                                                    ? selectedArrowColor
                                                    : ( treeNodeIdPair.includes( selectedKey as string ?? '' )
                                                            ? linkedToNodeArrowColor
                                                            : arrowColor
                                                    )
                                            }
                                            strokeWidth={2}
                                            // this quirk is used to re-render arrows on each render cycle
                                            SVGcanvasStyle={{}}
                                            divContainerStyle={{
                                                zIndex: selectedArrow?.[ 0 ] === treeNodeIdPair[ 0 ] && selectedArrow?.[ 1 ] === treeNodeIdPair[ 1 ]
                                                    ? 99999
                                                    : ( treeNodeIdPair.includes( selectedKey as string ?? '' )
                                                            ? 99998
                                                            : 99997
                                                    )
                                            }}
                                            start={treeNodeIdPair[ 0 ]}
                                            end={treeNodeIdPair[ 1 ]}
                                            passProps={{
                                                onClick      : () => {
                                                    this.setState( { selectedArrow: treeNodeIdPair } );
                                                },
                                                onContextMenu: ( e : React.MouseEvent<SVGRectElement, MouseEvent> ) => {
                                                    this.setState( { selectedArrow: treeNodeIdPair } );
                                                    this.cm?.show( e )
                                                    e.preventDefault();
                                                }/*,
                                                onKeyPress   : ( e : React.KeyboardEvent<SVGRectElement> ) => {
                                                    console.log( e );
                                                }*/
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            <Toolbar
                                className="yn-panel-toolbar shadow-4"
                                style={{ width: '100%', zIndex: 2, flex: '0 0 auto' }}
                                start={
                                    <>
                                        <label className="ml-2 mr-3">Show Arrows to </label>
                                        {dataObjectTargets.map( targetTypeName =>
                                            <div className="flex align-items-center" key={uid + '-' + targetTypeName}
                                                 style={{ marginRight: '1em' }}>
                                                <Checkbox id={uid + '-' + targetTypeName}
                                                          checked={showDataObjectTargets[ targetTypeName ] !== false} value={targetTypeName}
                                                          onChange={this.toggleShowDataObjectTargets}/>
                                                <label htmlFor={uid + '-' + targetTypeName} className="ml-2">{targetTypeName}</label>
                                            </div> )
                                        }
                                    </>
                                }
                            />
                        </div>}
                        content={<>
                            {item &&
                                <LoadingMaskPanel
                                    forComponent={panelConfig?.panelType === 'Form' ? `${uid}_form-${item.id}` : `${uid}_attributes-${item.id}`}
                                    className="yn-flex-layout-parent"
                                    style={{ position: 'absolute', width: '100% !important', height: '100% !important' }}>
                                    <div key={`${uid}_formview`} className="yn-content-panel-container yn-formview-panel"
                                         style={{ flexFlow: 'row wrap', justifyContent: 'start' }}>
                                        {panelConfig?.panelType === 'Form' && ( treeInFocus !== 'DataObjects' || item.id !== rootItemId || item.itemType.name !== 'Form' ) &&
                                            <Form
                                                uid={`${uid}_form-${item.id}`}
                                                dataContext={dataContext}
                                                additionalElusiveDataContexts={[ uid + '_DataObjects' ]}
                                                schema={schema}
                                                viewKey={panelConfig.viewKey}

                                                mode="embedded"

                                                key={`${uid}_form-${item.id}`}

                                                {...formProps}

                                                rootItemId={item.id}
                                                treeParentItemId={parentPayloadId}
                                                treeRootItemId={rootItemId}
                                                treeVariables={treeVariables?.[ treeInFocus ]}
                                                treeSetVariables={this.onSetTreeVariables}
                                            />
                                        }
                                        {panelConfig?.panelType !== 'Form' &&
                                            <AttributesForm
                                                uid={`${uid}_attributes-${item.id}`}
                                                dataContext={dataContext}

                                                style={{ padding: 0 }}

                                                {...attributesPanelProps}

                                                schema={schema}
                                                status={status}
                                                timestamp={timestamp}
                                                timezone={timezone}

                                                item={item}

                                                rawMode={rawMode}
                                                showAdditionalRawNames={showAdditionalRawNames}

                                                editable
                                            />
                                        }
                                    </div>
                                </LoadingMaskPanel>
                            }
                        </>}
                        onMenuWidthChange={this.onMenuWidthChange}
                    />
                </Xwrapper>
            </LoadingMaskPanel>
        </>;
    }
}


// redux stuff

/**
 *
 * @param state
 * @param ownProps
 */
function mapStateToProps( state : StoreState, ownProps : AllProps ) {
    const retVal : Partial<Props> = {};

    if ( ownProps.uid ) {

        // get intercom messages
        if ( state.intercom?.[ ownProps.uid ] ) {
            retVal.intercomMessages = state.intercom[ ownProps.uid ];
        }

        // get elusiveData
        if ( state.elusiveData?.[ ownProps.uid ] ) {
            retVal.elusiveData = state.elusiveData[ ownProps.uid ];
        }
        for ( const treeInFocus of treeInFocusKeys ) {
            if ( state.elusiveData[ `${ownProps.uid}_${treeInFocus}` ] ) {
                if ( !retVal.treeVariables ) {
                    retVal.treeVariables = {};
                }
                retVal.treeVariables[ treeInFocus ] = state.elusiveData[ `${ownProps.uid}_${treeInFocus}` ]?.variables;
            }
        }
    }

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

/**
 * Bind action creators to component props
 * @param dispatch
 * @return {*}
 */
function mapDispatchToProps( dispatch : Dispatch ) {
    return bindActionCreators( Actions, dispatch );
}

export default connect( mapStateToProps, mapDispatchToProps )( ViewDesigner );
